import React from "react";
import { Box } from "@mui/material";
import { INK } from "../theme/brand";

const PHONE_WIDTH = 252;
const PHONE_HEIGHT = 528;

// Reines CSS-Gehäuse (kein echtes Produktfoto) – der Rahmen, in dem die
// animierten App-Screens (siehe PhoneUsageDemo) ablaufen.
export default function PhoneFrame({ children }) {
  return (
    <Box
      sx={{
        position: "relative",
        width: PHONE_WIDTH,
        height: PHONE_HEIGHT,
        bgcolor: INK,
        borderRadius: "40px",
        p: "10px",
        boxShadow: "0 40px 90px rgba(0,0,0,0.45), inset 0 0 0 1px rgba(255,255,255,0.08)",
        flexShrink: 0,
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 10,
          left: "50%",
          transform: "translateX(-50%)",
          width: 88,
          height: 20,
          bgcolor: INK,
          borderRadius: "0 0 14px 14px",
          zIndex: 2,
        }}
      />
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
          bgcolor: "#f7f7f9",
          borderRadius: "30px",
          overflow: "hidden",
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          position: "absolute",
          bottom: 8,
          left: "50%",
          transform: "translateX(-50%)",
          width: 96,
          height: 4,
          borderRadius: 4,
          bgcolor: "rgba(255,255,255,0.35)",
        }}
      />
    </Box>
  );
}
